import { PopularSeriesSection } from '@/shared/api-generated-types'
import CardRow from '@/widgets/CardRow'
import SeriesCard, { Props as SeriesCardProps } from '@/widgets/SeriesCard'
import React from 'react'

export interface Props extends Partial<PopularSeriesSection> {}

const PopularSeriesBlock = ({ ...props }: Props): JSX.Element | null => {
  if (!props.items?.length) return null

  const seriesCards = props.items.map((item) => {
    return <SeriesCard key={`class_${item.id}`} {...(item as SeriesCardProps)} />
  })

  return (
    <CardRow title={props.title} subtitle={props.subtitle} theme="white" navigationActions={props.navigationActions}>
      {seriesCards}
    </CardRow>
  )
}
export default React.memo(PopularSeriesBlock)
